import React from 'react';
import BarItemsInfo from 'flow/components/pbx/supervisor/QueueRow/BarItemsInfo';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectQueueHasOmniSupport } from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';

interface Props {
    queueKey: QueueKey;
    number?: number;
}

const WaitingQueueItemsInfo = ({ queueKey, number }: Props) => {
    const { i18next } = useAppContext();
    const queueIsOfTypeOmni = useAppSelector((state) =>
        selectQueueHasOmniSupport(state, queueKey),
    );

    return (
        <BarItemsInfo
            tooltipLabel={
                queueIsOfTypeOmni
                    ? i18next.t('Queue.InQueue.Section.Title')
                    : i18next.t('Queue.CallsInQueue.Section.Title')
            }
            icon={queueIsOfTypeOmni ? 'omni-queue' : 'phone'}
            number={number}
        />
    );
};

export default WaitingQueueItemsInfo;
